module.exports = __webpack_public_path__ + "img/ki.9f8d51d0.svg";